import { RaisedButton } from "material-ui";

const React = require("react");

export default class RowUserPage extends React.Component {
  render() {
    return (
      <tr>
        <td>{this.props.email}</td>
        <td>{this.props.name}</td>
        <td>{this.props.department}</td>
        <td>{this.props.isActive ? "Activ" : "Inactiv"}</td>
        <td>
          <RaisedButton
            primary
            label={"Edit"}
            onClick={() =>
              this.props.onEditClicked(
                this.props.id,
                this.props.firstName,
                this.props.middleName,
                this.props.lastName,
                this.props.email,
                this.props.positionId,
                this.props.roleId,
                this.props.departmentId,
                this.props.isActive,
                this.props.canSeeAllReports,
                this.props.canEditAcquisitionsReports,
                this.props.canEditAccountingReports,
                this.props.canEditReceptionReports,
                this.props.canSeeContracts,
                this.props.canSeeApprovedPapers,
                this.props.canSeeAllPapers,
                this.props.canSeePapersExcelReport,
                this.props.signatureLink,
                this.props.canSetPaperAsPrinted
              )
            }
          />
          <RaisedButton
            style={{ marginLeft: "10px" }}
            secondary
            label={"Delete"}
            onClick={() =>
              this.props.onDeleteClicked(this.props.index, this.props.id)
            }
          />
        </td>
      </tr>
    );
  }
}
